/**-----------------------------------------------------------------------------------------
* Copyright © 2020 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
import { Input, Component, forwardRef, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, HostBinding, Directive, TemplateRef, Optional, NgZone, EventEmitter, ElementRef, ContentChild, Output, NgModule } from '@angular/core';
import { ComponentMessages, LocalizationService, L10N_PREFIX } from '@progress/kendo-angular-l10n';
import { Subject, Subscription } from 'rxjs';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { Keys, anyChanged, ResizeSensorComponent, EventsModule, ResizeSensorModule } from '@progress/kendo-angular-common';
import { CommonModule } from '@angular/common';

/**
 * @hidden
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@progress/kendo-angular-l10n';
import * as ɵngcc2 from '@progress/kendo-angular-dropdowns';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@progress/kendo-angular-inputs';
import * as ɵngcc5 from '@progress/kendo-angular-common';

const _c0 = ["dropdownlist"];
function PagerNumericButtonsComponent_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1, "... ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.pageLabel(ctx_r0.start - 1));
} }
const _c1 = function (a1) { return { "k-link": true, "k-state-selected": a1 }; };
function PagerNumericButtonsComponent_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const num_r6 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("value", num_r6.toString())("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c1, ctx_r1.currentPage == num_r6));
    ɵngcc0.ɵɵattribute("aria-label", ctx_r1.pageLabel(num_r6))("aria-current", ctx_r1.currentPage == num_r6 ? "page" : undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", num_r6, " ");
} }
function PagerNumericButtonsComponent_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1, "... ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.pageLabel(ctx_r2.end + 1));
} }
function PagerNumericButtonsComponent_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "button", 10);
    ɵngcc0.ɵɵlistener("click", function PagerNumericButtonsComponent_li_5_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.changePage(ctx_r7.start - 2); });
    ɵngcc0.ɵɵtext(2, "...");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r3.pageLabel(ctx_r3.start - 1));
} }
function PagerNumericButtonsComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "button", 11);
    ɵngcc0.ɵɵlistener("click", function PagerNumericButtonsComponent_li_6_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const num_r9 = ctx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.changePage(num_r9 - 1); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const num_r9 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c1, ctx_r4.currentPage == num_r9));
    ɵngcc0.ɵɵattribute("aria-label", ctx_r4.pageLabel(num_r9))("aria-current", ctx_r4.currentPage == num_r9 ? "page" : undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", num_r9, " ");
} }
function PagerNumericButtonsComponent_li_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "button", 10);
    ɵngcc0.ɵɵlistener("click", function PagerNumericButtonsComponent_li_7_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.changePage(ctx_r12.end); });
    ɵngcc0.ɵɵtext(2, "...");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r5.pageLabel(ctx_r5.end + 1));
} }
const _c2 = function () { return { "k-pager-numbers": true, "k-reset": true }; };
const _c3 = function () { return { "k-pager-input": true, "k-label": true }; };
const _c4 = function (a0, a1) { return { keydown: a0, focusout: a1 }; };
var I18N_5;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The label for the first page button in the Pager
     * @meaning kendo.pager.firstPage
     */ 
    const MSG_EXTERNAL_7169522157181311670$$DIST_FESM2015_INDEX_JS_6 = goog.getMsg("Go to the first page");
    I18N_5 = MSG_EXTERNAL_7169522157181311670$$DIST_FESM2015_INDEX_JS_6;
}
else {
    I18N_5 = $localize `:kendo.pager.firstPage|The label for the first page button in the Pager␟58e7a29204d61160ee51887924108de65eacf790␟7169522157181311670:Go to the first page`;
}
var I18N_7;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The label for the previous page button in the Pager
     * @meaning kendo.pager.previousPage
     */ 
    const MSG_EXTERNAL_3173443332469111280$$DIST_FESM2015_INDEX_JS_8 = goog.getMsg("Go to the previous page");
    I18N_7 = MSG_EXTERNAL_3173443332469111280$$DIST_FESM2015_INDEX_JS_8;
}
else {
    I18N_7 = $localize `:kendo.pager.previousPage|The label for the previous page button in the Pager␟8143f473e772fc1492c1a924b01a8f1251e9d02f␟3173443332469111280:Go to the previous page`;
}
var I18N_9;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The label for the next page button in the Pager
     * @meaning kendo.pager.nextPage
     */ 
    const MSG_EXTERNAL_2977649834936444534$$DIST_FESM2015_INDEX_JS_10 = goog.getMsg("Go to the next page");
    I18N_9 = MSG_EXTERNAL_2977649834936444534$$DIST_FESM2015_INDEX_JS_10;
}
else {
    I18N_9 = $localize `:kendo.pager.nextPage|The label for the next page button in the Pager␟f49126ed375f9ee2c308b79a4e79eb8cabcc05ee␟2977649834936444534:Go to the next page`;
}
var I18N_11;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The label for the last page button in the Pager
     * @meaning kendo.pager.lastPage
     */ 
    const MSG_EXTERNAL_4302174378452165800$$DIST_FESM2015_INDEX_JS_12 = goog.getMsg("Go to the last page");
    I18N_11 = MSG_EXTERNAL_4302174378452165800$$DIST_FESM2015_INDEX_JS_12;
}
else {
    I18N_11 = $localize `:kendo.pager.lastPage|The label for the last page button in the Pager␟f995be404141d2d8026e932413f9cfcceb248b7e␟4302174378452165800:Go to the last page`;
}
var I18N_13;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The label before the current page number in the Pager
     * @meaning kendo.pager.page
     */ 
    const MSG_EXTERNAL_8678868632586383003$$DIST_FESM2015_INDEX_JS_14 = goog.getMsg("Page");
    I18N_13 = MSG_EXTERNAL_8678868632586383003$$DIST_FESM2015_INDEX_JS_14;
}
else {
    I18N_13 = $localize `:kendo.pager.page|The label before the current page number in the Pager␟a4889149ce04e1dfd6df1a1b6ddb0181c4853815␟8678868632586383003:Page`;
}
var I18N_15;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The label before the total pages number in the Pager
     * @meaning kendo.pager.of
     */ 
    const MSG_EXTERNAL_2438575870810538060$$DIST_FESM2015_INDEX_JS_16 = goog.getMsg("of");
    I18N_15 = MSG_EXTERNAL_2438575870810538060$$DIST_FESM2015_INDEX_JS_16;
}
else {
    I18N_15 = $localize `:kendo.pager.of|The label before the total pages number in the Pager␟97c61905bdc8392cc3703e78f39409b350971a56␟2438575870810538060:of`;
}
var I18N_17;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The label for the pager input in the Pager
     * @meaning kendo.pager.pageNumberInputTitle
     */ 
    const MSG_EXTERNAL_2330948786674386987$$DIST_FESM2015_INDEX_JS_18 = goog.getMsg("Page Number");
    I18N_17 = MSG_EXTERNAL_2330948786674386987$$DIST_FESM2015_INDEX_JS_18;
}
else {
    I18N_17 = $localize `:kendo.pager.pageNumberInputTitle|The label for the pager input in the Pager␟73fa30054b2ba79a6eee49301ceabf8766101e91␟2330948786674386987:Page Number`;
}
var I18N_19;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The label after the total pages number in the Pager
     * @meaning kendo.pager.items
     */ 
    const MSG_EXTERNAL_3496480700570244582$$DIST_FESM2015_INDEX_JS_20 = goog.getMsg("items");
    I18N_19 = MSG_EXTERNAL_3496480700570244582$$DIST_FESM2015_INDEX_JS_20;
}
else {
    I18N_19 = $localize `:kendo.pager.items|The label after the total pages number in the Pager␟972389bced646be7aee572a38aaed254caaa96f1␟3496480700570244582:items`;
}
var I18N_21;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The label for the page size chooser in the Pager
     * @meaning kendo.pager.itemsPerPage
     */ 
    const MSG_EXTERNAL_1737032542950161383$$DIST_FESM2015_INDEX_JS_22 = goog.getMsg("items per page");
    I18N_21 = MSG_EXTERNAL_1737032542950161383$$DIST_FESM2015_INDEX_JS_22;
}
else {
    I18N_21 = $localize `:kendo.pager.itemsPerPage|The label for the page size chooser in the Pager␟341bf05d4bc3fd82b12c8fb0b230ca413fcedf6f␟1737032542950161383:items per page`;
}
const _c23 = ["firstPage", I18N_5, "previousPage", I18N_7, "nextPage", I18N_9, "lastPage", I18N_11, "page", I18N_13, "of", I18N_15, "pageNumberInputTitle", I18N_17, "items", I18N_19, "itemsPerPage", I18N_21];
function PagerComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template.templateRef)("ngTemplateOutletContext", ctx_r0.templateContext);
} }
function PagerComponent_ng_container_3_kendo_datapager_prev_buttons_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-datapager-prev-buttons");
} }
function PagerComponent_ng_container_3_kendo_datapager_numeric_buttons_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-datapager-numeric-buttons", 6);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("buttonCount", ctx_r3.buttonCount);
} }
function PagerComponent_ng_container_3_kendo_datapager_input_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-datapager-input");
} }
function PagerComponent_ng_container_3_kendo_datapager_next_buttons_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-datapager-next-buttons");
} }
function PagerComponent_ng_container_3_kendo_datapager_info_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-datapager-info");
} }
function PagerComponent_ng_container_3_kendo_datapager_page_sizes_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-datapager-page-sizes", 7);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("pageSizes", ctx_r7.pageSizeValues);
} }
function PagerComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PagerComponent_ng_container_3_kendo_datapager_prev_buttons_1_Template, 1, 0, "kendo-datapager-prev-buttons", 2);
    ɵngcc0.ɵɵtemplate(2, PagerComponent_ng_container_3_kendo_datapager_numeric_buttons_2_Template, 1, 1, "kendo-datapager-numeric-buttons", 4);
    ɵngcc0.ɵɵtemplate(3, PagerComponent_ng_container_3_kendo_datapager_input_3_Template, 1, 0, "kendo-datapager-input", 2);
    ɵngcc0.ɵɵtemplate(4, PagerComponent_ng_container_3_kendo_datapager_next_buttons_4_Template, 1, 0, "kendo-datapager-next-buttons", 2);
    ɵngcc0.ɵɵtemplate(5, PagerComponent_ng_container_3_kendo_datapager_info_5_Template, 1, 0, "kendo-datapager-info", 2);
    ɵngcc0.ɵɵtemplate(6, PagerComponent_ng_container_3_kendo_datapager_page_sizes_6_Template, 1, 1, "kendo-datapager-page-sizes", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.previousNext);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.type === "numeric" && ctx_r1.buttonCount > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.type === "input");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.previousNext);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.info);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.pageSizeValues);
} }
class PreventableEvent {
    constructor() {
        this.prevented = false;
    }
    /**
     * Prevents the default action for a specified event.
     * In this way, the source component suppresses the built-in behavior that follows the event.
     */
    preventDefault() {
        this.prevented = true;
    }
    /**
     * If the event is prevented by any of its subscribers, returns `true`.
     *
     * @returns `true` if the default action was prevented. Otherwise, returns `false`.
     */
    isDefaultPrevented() {
        return this.prevented;
    }
}

/**
 * Arguments for the `pageSizeChange` event. The `pageSizeChange` event fires when the page size
 * is changed from the UI. If you cancel the event, the change is prevented.
 */
class PageSizeChangeEvent extends PreventableEvent {
    /**
     * Constructs the event arguments for the `pageSizeChange` event.
     * @param newPageSize - The newly selected page size.
     * @hidden
     */
    constructor(newPageSize) {
        super();
        this.newPageSize = newPageSize;
    }
}

/**
 * @hidden
 */
class Messages extends ComponentMessages {
}
Messages.ɵfac = function Messages_Factory(t) { return ɵMessages_BaseFactory(t || Messages); };
Messages.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: Messages, inputs: { firstPage: "firstPage", lastPage: "lastPage", previousPage: "previousPage", nextPage: "nextPage", page: "page", pageNumberInputTitle: "pageNumberInputTitle", itemsPerPage: "itemsPerPage", of: "of", items: "items" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
Messages.propDecorators = {
    firstPage: [{ type: Input }],
    lastPage: [{ type: Input }],
    previousPage: [{ type: Input }],
    nextPage: [{ type: Input }],
    page: [{ type: Input }],
    pageNumberInputTitle: [{ type: Input }],
    itemsPerPage: [{ type: Input }],
    of: [{ type: Input }],
    items: [{ type: Input }]
};
const ɵMessages_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(Messages);

/**
 * Custom component messages override default component messages
 * ([see example]({% slug pager_globalization %}#toc-messages)).
 */
class CustomMessagesComponent extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
    get override() {
        return true;
    }
}
CustomMessagesComponent.ɵfac = function CustomMessagesComponent_Factory(t) { return new (t || CustomMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
CustomMessagesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CustomMessagesComponent, selectors: [["kendo-datapager-messages"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                useExisting: forwardRef(() => CustomMessagesComponent)
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function CustomMessagesComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
CustomMessagesComponent.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CustomMessagesComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        useExisting: forwardRef(() => CustomMessagesComponent)
                    }
                ],
                selector: 'kendo-datapager-messages',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

/**
 * @hidden
 */
class PagerContextService {
    constructor() {
        this.changes = new Subject();
        this.pageChange = new Subject();
        this.pageSizeChange = new Subject();
    }
    get currentPage() {
        return this.skip / this.pageSize;
    }
    notifyChanges(changes) {
        this.total = changes.total;
        this.pageSize = changes.pageSize;
        this.skip = changes.skip;
        this.changes.next(changes);
    }
    changePage(page) {
        this.pageChange.next({ skip: page * this.pageSize, take: this.pageSize });
    }
    changePageSize(event) {
        this.pageSizeChange.next(event);
    }
    nextPage() {
        const nextPage = this.currentPage + 1;
        if (nextPage * this.pageSize <= this.total) {
            this.changePage(nextPage);
        }
    }
    prevPage() {
        const prevPage = this.currentPage - 1;
        if (prevPage * this.pageSize >= 0) {
            this.changePage(prevPage);
        }
    }
}
PagerContextService.ɵfac = function PagerContextService_Factory(t) { return new (t || PagerContextService)(); };
PagerContextService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: PagerContextService, factory: PagerContextService.ɵfac });


/**
 * @hidden
 */
class PagerElementComponent {
    constructor(localization, pagerContext, cd) {
        this.localization = localization;
        this.pagerContext = pagerContext;
        this.cd = cd;
        this.total = this.pagerContext.total;
        this.skip = this.pagerContext.skip;
        this.pageSize = this.pagerContext.pageSize;
    }
    /**
     * @hidden
     *
     * @readonly
     * @type {number}
     * @memberOf PagerElementComponent
     */
    get currentPage() {
        return Math.floor((this.skip || 0) / this.pageSize) + 1;
    }
    /**
     * @hidden
     *
     * @readonly
     * @type {number}
     * @memberOf PagerElementComponent
     */
    get totalPages() {
        return Math.ceil((this.total || 0) / this.pageSize);
    }
    /**
     * @hidden
     *
     * @param {string} key
     * @returns {string}
     *
     * @memberOf PagerElementComponent
     */
    textFor(key) {
        return this.localization.get(key);
    }
    /**
     * @hidden
     *
     * @param {number} page
     *
     * @memberOf PagerElementComponent
     */
    changePage(page) {
        this.pagerContext.changePage(page);
        return false;
    }
    /**
     * @hidden
     *
     * @memberOf PagerElementComponent
     */
    ngOnInit() {
        this.subscriptions = this.pagerContext.changes.subscribe(this.onChanges.bind(this));
        this.subscriptions.add(this.localization.changes.subscribe(() => this.cd.markForCheck()));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    }
}
PagerElementComponent.ɵfac = function PagerElementComponent_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
PagerElementComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PagerElementComponent });


// tslint:disable:no-access-missing-member
/**
 * Displays buttons for navigating to the first and to the previous page ([see example]({% slug pager_settings %})).
 */
class PagerPrevButtonsComponent extends PagerElementComponent {
    constructor(localization, pagerContext, cd) {
        super(localization, pagerContext, cd);
    }
    /**
     * @hidden
     *
     * @readonly
     * @type {boolean}
     * @memberOf PagerPrevButtonsComponent
     */
    get disabled() {
        return this.currentPage === 1 || !this.total;
    }
    onChanges({ total, skip, pageSize }) {
        this.total = total;
        this.skip = skip;
        this.pageSize = pageSize;
        this.cd.markForCheck();
    }
}
PagerPrevButtonsComponent.ɵfac = function PagerPrevButtonsComponent_Factory(t) { return new (t || PagerPrevButtonsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(PagerContextService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
PagerPrevButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PagerPrevButtonsComponent, selectors: [["kendo-datapager-prev-buttons"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 12, consts: [["type", "button", 1, "k-link", "k-pager-nav", "k-pager-first", 3, "title", "click"], [1, "k-icon", "k-i-seek-w"], ["type", "button", 1, "k-link", "k-pager-nav", 3, "title", "click"], [1, "k-icon", "k-i-arrow-w"]], template: function PagerPrevButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function PagerPrevButtonsComponent_Template_button_click_0_listener() { return ctx.currentPage !== 1 ? ctx.changePage(0) : false; });
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function PagerPrevButtonsComponent_Template_button_click_2_listener() { return ctx.currentPage !== 1 ? ctx.changePage(ctx.currentPage - 2) : false; });
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-state-disabled", ctx.disabled);
        ɵngcc0.ɵɵproperty("title", ctx.textFor("firstPage"));
        ɵngcc0.ɵɵattribute("aria-label", ctx.textFor("firstPage"))("aria-disabled", ctx.disabled ? true : undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-label", ctx.textFor("firstPage"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("k-state-disabled", ctx.disabled);
        ɵngcc0.ɵɵproperty("title", ctx.textFor("previousPage"));
        ɵngcc0.ɵɵattribute("aria-label", ctx.textFor("previousPage"))("aria-disabled", ctx.disabled ? true : undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-label", ctx.textFor("previousPage"));
    } }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
PagerPrevButtonsComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: PagerContextService },
    { type: ChangeDetectorRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerPrevButtonsComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'kendo-datapager-prev-buttons',
                template: `
        <button
            type="button"
            class="k-link k-pager-nav k-pager-first"
            [class.k-state-disabled]="disabled"
            [title]="textFor('firstPage')"
            [attr.aria-label]="textFor('firstPage')"
            [attr.aria-disabled]="disabled ? true : undefined"
            (click)="currentPage !== 1 ? changePage(0) : false">
            <span class="k-icon k-i-seek-w" [attr.aria-label]="textFor('firstPage')"></span>
        </button>
        <button
            type="button"
            class="k-link k-pager-nav"
            [class.k-state-disabled]="disabled"
            [title]="textFor('previousPage')"
            [attr.aria-label]="textFor('previousPage')"
            [attr.aria-disabled]="disabled ? true : undefined"
            (click)="currentPage !== 1 ? changePage(currentPage-2) : false">
            <span class="k-icon k-i-arrow-w" [attr.aria-label]="textFor('previousPage')"></span>
        </button>
    `
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }, { type: PagerContextService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

/**
 * Displays a drop-down list for the page size selection ([see example]({% slug pager_settings %})).
 */
class PagerPageSizesComponent extends PagerElementComponent {
    constructor(localization, cd, pagerContext) {
        super(localization, pagerContext, cd);
        this.pagerContext = pagerContext;
        this._pageSizes = [];
    }
    get pageSizes() {
        return this._pageSizes;
    }
    /**
     * The page sizes collection. Can contain numbers and [PageSizeItem]({% slug api_pager_pagesizeitem %}) objects.
     *
     * @example
     * {% meta height:400 %}
     * ```ts-preview
     * _@Component({
     *    selector: 'my-app',
     *    template: `
     *        <div *ngFor="let item of pagedData" style="border: 1px solid black; padding: 10px;">
     *            <span>{{item.ProductID}}. </span>
     *            <span>{{item.ProductName}}</span>
     *        </div>
     *        <kendo-datapager
     *             [skip]="skip"
     *             [pageSize]="pageSize"
     *             [total]="total"
     *             (pageChange)="onPageChange($event)">
     *           <ng-template kendoDataPagerTemplate>
     *               <kendo-datapager-page-sizes [pageSizes]="pagesizes"></kendo-datapager-page-sizes>
     *           </ng-template>
     *        </kendo-datapager>
     *    `
     * })
     * class AppComponent {
     *    public data: any[] = products;
     *    public pagedData = [];
     *    public skip = 0;
     *    public pageSize = 2;
     *    public total = products.length;
     *    public pagesizes = [{text: 'One', value: 1}, {text: 'Two', value: 2}, {text: 'All', value : 'all'}];
     *
     *    public ngOnInit() {
     *        this.pageData();
     *    }
     *
     *    public onPageChange(e) {
     *        this.skip = e.skip;
     *        this.pageSize = e.take;
     *        this.pageData();
     *    }
     *
     *    private pageData() {
     *        this.pagedData = this.data.slice(this.skip, this.skip + this.pageSize);
     *    }
     * }
     *
     * const products = [{
     *   'ProductID' : 1,
     *   'ProductName' : "Chai",
     *   'SupplierID' : 1,
     *   'CategoryID' : 1,
     *   'QuantityPerUnit' : "10 boxes x 20 bags",
     *   'UnitPrice' : 18.0000,
     *   'UnitsInStock' : 39,
     *   'UnitsOnOrder' : 0,
     *   'ReorderLevel' : 10,
     *   'Discontinued' : false
     *
     * }, {
     *   'ProductID' : 2,
     *   'ProductName' : "Chang",
     *   'SupplierID' : 1,
     *   'CategoryID' : 1,
     *   'QuantityPerUnit' : "24 - 12 oz bottles",
     *   'UnitPrice' : 19.0000,
     *   'UnitsInStock' : 17,
     *   'UnitsOnOrder' : 40,
     *   'ReorderLevel' : 25,
     *   'Discontinued' : false
     * }, {
     *   'ProductID' : 3,
     *   'ProductName' : "Aniseed Syrup",
     *   'SupplierID' : 1,
     *   'CategoryID' : 2,
     *   'QuantityPerUnit' : "12 - 550 ml bottles",
     *   'UnitPrice' : 10.0000,
     *   'UnitsInStock' : 13,
     *   'UnitsOnOrder' : 70,
     *   'ReorderLevel' : 25,
     *   'Discontinued' : false
     * }, {
     *   'ProductID' : 4,
     *   'ProductName' : "Chef Anton\'s Cajun Seasoning",
     *   'SupplierID' : 2,
     *  'CategoryID' : 2,
     *   'QuantityPerUnit' : "48 - 6 oz jars",
     *   'UnitPrice' : 22.0000,
     *   'UnitsInStock' : 53,
     *   'UnitsOnOrder' : 0,
     *   'ReorderLevel' : 0,
     *   'Discontinued' : false
     * }, {
     *   'ProductID' : 5,
     *   'ProductName' : "Chef Anton\'s Gumbo Mix",
     *   'SupplierID' : 2,
     *   'CategoryID' : 2,
     *   'QuantityPerUnit' : "36 boxes",
     *   'UnitPrice' : 21.3500,
     *   'UnitsInStock' : 0,
     *   'UnitsOnOrder' : 0,
     *   'ReorderLevel' : 0,
     *   'Discontinued' : true
     * }, {
     *   'ProductID' : 6,
     *   'ProductName' : "Grandma\'s Boysenberry Spread",
     *   'SupplierID' : 3,
     *   'CategoryID' : 2,
     *   'QuantityPerUnit' : "12 - 8 oz jars",
     *   'UnitPrice' : 25.0000,
     *   'UnitsInStock' : 120,
     *   'UnitsOnOrder' : 0,
     *   'ReorderLevel' : 25,
     *   'Discontinued' : false
     * }];
     * ```
     * {% endmeta %}
     */
    set pageSizes(pageSizes) {
        let normalizedItems = [];
        pageSizes.forEach(item => {
            if (typeof item === 'number') {
                normalizedItems.push({
                    text: item.toString(),
                    value: item
                });
            }
            else {
                normalizedItems.push(item);
            }
        });
        if (this.pageSize && !normalizedItems.some(item => item.value === this.pageSize)) {
            normalizedItems = [{ text: this.pageSize.toString(), value: this.pageSize }, ...normalizedItems];
        }
        this._pageSizes = normalizedItems;
    }
    /**
     * @hidden
     *
     * @readonly
     */
    get classes() {
        return true;
    }
    ngAfterViewInit() {
        this.dropDownList.wrapper.nativeElement.setAttribute('aria-label', this.textFor('itemsPerPage'));
    }
    /**
     * @hidden
     */
    pageSizeChange(value, dropdownlist) {
        const event = new PageSizeChangeEvent(value);
        this.pagerContext.changePageSize(event);
        if (event.isDefaultPrevented()) {
            dropdownlist.writeValue(this.pageSize);
        }
    }
    onChanges({ total, skip, pageSize }) {
        this.total = total;
        this.skip = skip;
        this.pageSize = typeof pageSize === 'number' ? pageSize : this.total;
        this.cd.markForCheck();
    }
}
PagerPageSizesComponent.ɵfac = function PagerPageSizesComponent_Factory(t) { return new (t || PagerPageSizesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(PagerContextService)); };
PagerPageSizesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PagerPageSizesComponent, selectors: [["kendo-datapager-page-sizes"]], viewQuery: function PagerPageSizesComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropDownList = _t.first);
    } }, hostVars: 4, hostBindings: function PagerPageSizesComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-pager-sizes", ctx.classes)("k-label", ctx.classes);
    } }, inputs: { pageSizes: "pageSizes" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 4, consts: [["textField", "text", "valueField", "value", 3, "data", "valuePrimitive", "value", "valueChange"], ["dropdownlist", ""]], template: function PagerPageSizesComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "kendo-dropdownlist", 0, 1);
        ɵngcc0.ɵɵlistener("valueChange", function PagerPageSizesComponent_Template_kendo_dropdownlist_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r1); const _r0 = ɵngcc0.ɵɵreference(1); return ctx.pageSizeChange($event, _r0); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("data", ctx.pageSizes)("valuePrimitive", true)("value", ctx.pageSize);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor("itemsPerPage"), " ");
    } }, directives: [ɵngcc2.DropDownListComponent], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
PagerPageSizesComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: ChangeDetectorRef },
    { type: PagerContextService }
];
PagerPageSizesComponent.propDecorators = {
    dropDownList: [{ type: ViewChild, args: ['dropdownlist', { static: true },] }],
    pageSizes: [{ type: Input }],
    classes: [{ type: HostBinding, args: ["class.k-pager-sizes",] }, { type: HostBinding, args: ["class.k-label",] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerPageSizesComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'kendo-datapager-page-sizes',
                template: `
        <kendo-dropdownlist
            #dropdownlist
            [data]="pageSizes"
            textField="text"
            valueField="value"
            [valuePrimitive]="true"
            [value]="pageSize"
            (valueChange)="pageSizeChange($event, dropdownlist)"></kendo-dropdownlist>
        {{ textFor('itemsPerPage') }}
    `
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }, { type: PagerContextService }]; }, { pageSizes: [{
            type: Input
        }], classes: [{
            type: HostBinding,
            args: ["class.k-pager-sizes"]
        }, {
            type: HostBinding,
            args: ["class.k-label"]
        }], dropDownList: [{
            type: ViewChild,
            args: ['dropdownlist', { static: true }]
        }] }); })();

/**
 * Represents the pager template which helps to customize the pager appearance. To define a pager
 * template, nest an `<ng-template>` tag with the `kendoDataPagerTemplate` directive inside `<kendo-datapager>`.
 *
 * The template context provides the following fields:
 * * `currentPage`&mdash;The index of the displayed page.
 * * `pageSize`&mdash;The value of the current `pageSize`.
 * * `skip`&mdash;The current skip value.
 * * `total`&mdash;The total number of records.
 * * `totalPages`&mdash;The total number of available pages.
 *
 * @example
 * ```ts-preview
 *
 * _@Component({
 *     selector: 'my-app',
 *     template: `
 *       <kendo-datapager [total]="total" [pageSize]="pageSize" [skip]="skip" (pageChange)="onPageChange($event)">
 *           <ng-template kendoDataPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
 *               <kendo-datapager-prev-buttons></kendo-datapager-prev-buttons>
 *               <kendo-datapager-numeric-buttons [buttonCount]="10"></kendo-datapager-numeric-buttons>
 *               <kendo-datapager-next-buttons></kendo-datapager-next-buttons>
 *               <kendo-datapager-info></kendo-datapager-info>
 *               Current page: {{currentPage}}
 *           </ng-template>
 *        </kendo-datapager>
 *     `
 * })
 *
 * class AppComponent {
 *     public skip = 0;
 *     public pageSize = 10;
 *     public total = 100;
 *
 *     public onPageChange(e: any): void {
 *         this.skip = e.skip;
 *         this.pageSize = e.take;
 *     }
 * }
 *
 * ```
 */
class PagerTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
PagerTemplateDirective.ɵfac = function PagerTemplateDirective_Factory(t) { return new (t || PagerTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
PagerTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PagerTemplateDirective, selectors: [["", "kendoDataPagerTemplate", ""]] });
/** @nocollapse */
PagerTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoDataPagerTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Displays numeric buttons to enable navigation between the pages.
 */
class PagerNumericButtonsComponent extends PagerElementComponent {
    constructor(localization, cd, pagerContext) {
        super(localization, pagerContext, cd);
        this.pagerContext = pagerContext;
        this.numbersWrapClass = true;
    }
    /**
     * @hidden
     *
     * @readonly
     * @type {number[]}
     * @memberOf PagerNumericButtonsComponent
     */
    get buttons() {
        let result = [];
        for (let idx = this.start; idx <= this.end; idx++) {
            result.push(idx);
        }
        return result;
    }
    /**
     * @hidden
     */
    get end() {
        return Math.min((this.start + this.buttonCount) - 1, this.totalPages);
    }
    /**
     * @hidden
     */
    get start() {
        const page = this.currentPage;
        const buttonCount = this.buttonCount;
        if (page > buttonCount) {
            const reminder = (page % buttonCount);
            return (reminder === 0) ? (page - buttonCount) + 1 : (page - reminder) + 1;
        }
        return 1;
    }
    /**
     * @hidden
     */
    pageLabel(num) {
        const pageText = this.textFor('page');
        if (pageText) {
            return pageText + ' ' + num;
        }
        return num.toString();
    }
    /**
     * @hidden
     */
    onSelectChange(e) {
        const target = e.target;
        const valueAsNumber = Number(target.value);
        if (!Number.isNaN(valueAsNumber)) {
            this.changePage(valueAsNumber - 1);
        }
        else {
            if (target.value === 'previousButtons') {
                this.changePage(this.start - 2);
            }
            else {
                this.changePage(this.end);
            }
        }
    }
    onChanges({ total, skip, pageSize }) {
        this.total = total;
        this.skip = skip;
        this.pageSize = pageSize;
        this.cd.markForCheck();
    }
}
PagerNumericButtonsComponent.ɵfac = function PagerNumericButtonsComponent_Factory(t) { return new (t || PagerNumericButtonsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(PagerContextService)); };
PagerNumericButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PagerNumericButtonsComponent, selectors: [["kendo-datapager-numeric-buttons"]], hostVars: 2, hostBindings: function PagerNumericButtonsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-pager-numbers-wrap", ctx.numbersWrapClass);
    } }, inputs: { buttonCount: "buttonCount" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 9, consts: [[1, "k-dropdown", 3, "value", "change"], ["class", "k-link", "value", "previousButtons", 4, "ngIf"], [3, "value", "ngClass", 4, "ngFor", "ngForOf"], ["value", "nextButtons", "class", "k-link", 4, "ngIf"], [3, "ngClass"], [4, "ngIf"], [4, "ngFor", "ngForOf"], ["value", "previousButtons", 1, "k-link"], [3, "value", "ngClass"], ["value", "nextButtons", 1, "k-link"], ["type", "button", 1, "k-link", 3, "click"], ["type", "button", 3, "ngClass", "click"]], template: function PagerNumericButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "select", 0);
        ɵngcc0.ɵɵlistener("change", function PagerNumericButtonsComponent_Template_select_change_0_listener($event) { return ctx.onSelectChange($event); });
        ɵngcc0.ɵɵtemplate(1, PagerNumericButtonsComponent_option_1_Template, 2, 1, "option", 1);
        ɵngcc0.ɵɵtemplate(2, PagerNumericButtonsComponent_option_2_Template, 2, 7, "option", 2);
        ɵngcc0.ɵɵtemplate(3, PagerNumericButtonsComponent_option_3_Template, 2, 1, "option", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "ul", 4);
        ɵngcc0.ɵɵtemplate(5, PagerNumericButtonsComponent_li_5_Template, 3, 1, "li", 5);
        ɵngcc0.ɵɵtemplate(6, PagerNumericButtonsComponent_li_6_Template, 3, 6, "li", 6);
        ɵngcc0.ɵɵtemplate(7, PagerNumericButtonsComponent_li_7_Template, 3, 1, "li", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("value", ctx.currentPage.toString());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.start > 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.buttons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.end < ctx.totalPages);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction0(8, _c2));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.start > 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.buttons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.end < ctx.totalPages);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc3.NgClass], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
PagerNumericButtonsComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: ChangeDetectorRef },
    { type: PagerContextService }
];
PagerNumericButtonsComponent.propDecorators = {
    numbersWrapClass: [{ type: HostBinding, args: ['class.k-pager-numbers-wrap',] }],
    buttonCount: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerNumericButtonsComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'kendo-datapager-numeric-buttons',
                template: `
        <select
            class="k-dropdown"
            [value]="(currentPage).toString()"
            (change)="onSelectChange($event)">
            <option *ngIf="start > 1"
                class="k-link"
                value="previousButtons"
                [attr.aria-label]="pageLabel(start - 1)">...
            </option>
            <option *ngFor="let num of buttons"
                [value]="num.toString()"
                [attr.aria-label]="pageLabel(num)"
                [attr.aria-current]="currentPage == num ? 'page' : undefined"
                [ngClass]="{'k-link': true, 'k-state-selected':currentPage == num}">
                {{num}}
            </option>
            <option *ngIf="end < totalPages"
                value="nextButtons"
                class="k-link"
                [attr.aria-label]="pageLabel(end + 1)">...
            </option>
        </select>
        <ul [ngClass]="{'k-pager-numbers': true, 'k-reset': true}">
            <li *ngIf="start > 1">
                <button
                    type="button"
                    class="k-link"
                    [attr.aria-label]="pageLabel(start - 1)"
                    (click)="changePage(start - 2)">...</button>
            </li>
            <li *ngFor="let num of buttons">
                <button
                    type="button"
                    [attr.aria-label]="pageLabel(num)"
                    [attr.aria-current]="currentPage == num ? 'page' : undefined"
                    [ngClass]="{'k-link': true, 'k-state-selected':currentPage == num}"
                    (click)="changePage(num - 1)">
                    {{num}}
                </button>
            </li>
            <li *ngIf="end < totalPages">
                <button
                    type="button"
                    class="k-link"
                    [attr.aria-label]="pageLabel(end + 1)"
                    (click)="changePage(end)">...</button>
            </li>
        </ul>
    `
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }, { type: PagerContextService }]; }, { numbersWrapClass: [{
            type: HostBinding,
            args: ['class.k-pager-numbers-wrap']
        }], buttonCount: [{
            type: Input
        }] }); })();

// tslint:disable: no-access-missing-member
/**
 * Displays buttons for navigating to the next and to the last page ([see example]({% slug pager_settings %})).
 */
class PagerNextButtonsComponent extends PagerElementComponent {
    constructor(localization, pagerContext, cd) {
        super(localization, pagerContext, cd);
    }
    /**
     * @hidden
     *
     * @readonly
     * @type {boolean}
     * @memberOf PagerNextButtonsComponent
     */
    get disabled() {
        return this.currentPage === this.totalPages || !this.total;
    }
    onChanges({ total, skip, pageSize }) {
        this.total = total;
        this.skip = skip;
        this.pageSize = pageSize;
        this.cd.markForCheck();
    }
}
PagerNextButtonsComponent.ɵfac = function PagerNextButtonsComponent_Factory(t) { return new (t || PagerNextButtonsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(PagerContextService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
PagerNextButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PagerNextButtonsComponent, selectors: [["kendo-datapager-next-buttons"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 12, consts: [["type", "button", 1, "k-link", "k-pager-nav", 3, "title", "click"], [1, "k-icon", "k-i-arrow-e"], ["type", "button", 1, "k-link", "k-pager-nav", "k-pager-last", 3, "title", "click"], [1, "k-icon", "k-i-seek-e"]], template: function PagerNextButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function PagerNextButtonsComponent_Template_button_click_0_listener() { return ctx.currentPage !== ctx.totalPages ? ctx.changePage(ctx.currentPage) : false; });
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function PagerNextButtonsComponent_Template_button_click_2_listener() { return ctx.currentPage !== ctx.totalPages ? ctx.changePage(ctx.totalPages - 1) : false; });
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-state-disabled", ctx.disabled);
        ɵngcc0.ɵɵproperty("title", ctx.textFor("nextPage"));
        ɵngcc0.ɵɵattribute("aria-label", ctx.textFor("nextPage"))("aria-disabled", ctx.disabled ? true : undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-label", ctx.textFor("nextPage"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("k-state-disabled", ctx.disabled);
        ɵngcc0.ɵɵproperty("title", ctx.textFor("lastPage"));
        ɵngcc0.ɵɵattribute("aria-label", ctx.textFor("lastPage"))("aria-disabled", ctx.disabled ? true : undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-label", ctx.textFor("lastPage"));
    } }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
PagerNextButtonsComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: PagerContextService },
    { type: ChangeDetectorRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerNextButtonsComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'kendo-datapager-next-buttons',
                template: `
        <button
            type="button"
            class="k-link k-pager-nav"
            [class.k-state-disabled]="disabled"
            [title]="textFor('nextPage')"
            [attr.aria-label]="textFor('nextPage')"
            [attr.aria-disabled]="disabled ? true : undefined"
            (click)="currentPage !== totalPages ? changePage(currentPage) : false">
            <span class="k-icon k-i-arrow-e" [attr.aria-label]="textFor('nextPage')"></span>
        </button>
        <button
            type="button"
            class="k-link k-pager-nav k-pager-last"
            [class.k-state-disabled]="disabled"
            [title]="textFor('lastPage')"
            [attr.aria-label]="textFor('lastPage')"
            [attr.aria-disabled]="disabled ? true : undefined"
            (click)="currentPage !== totalPages ? changePage(totalPages-1) : false">
            <span class="k-icon k-i-seek-e" [attr.aria-label]="textFor('lastPage')"></span>
        </button>
    `
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }, { type: PagerContextService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

/**
 * Displays an input element which allows the typing and rendering of page numbers.
 */
class PagerInputComponent extends PagerElementComponent {
    constructor(localization, pagerContext, zone, cd) {
        super(localization, pagerContext, cd);
        this.pagerContext = pagerContext;
        this.zone = zone;
        /**
         * @hidden
         *
         * @param {string} value
         *
         * @memberOf PagerInputComponent
         */
        this.handleKeyDown = (event) => {
            let incomingValue = this.numericInput.value || this.current;
            // tslint:disable:deprecation
            if (event.keyCode === Keys.Enter) {
                event.preventDefault();
                if (incomingValue !== this.current) {
                    this.zone.run(() => {
                        this.changePage(incomingValue - 1);
                    });
                }
            }
        };
        /**
         * @hidden
         *
         * @param {string} value
         *
         * @memberOf PagerInputComponent
         */
        this.handleBlur = () => {
            const inputValue = this.numericInput.value;
            if (!inputValue) {
                this.numericInput.writeValue(this.current);
                return;
            }
            if (inputValue !== this.current) {
                this.zone.run(() => {
                    this.changePage(inputValue - 1);
                });
            }
        };
    }
    /**
     * @hidden
     */
    get current() {
        return this.hasPages ? this.currentPage : 0;
    }
    /**
     * @hidden
     */
    get hasPages() {
        return this.totalPages !== 0;
    }
    onChanges({ total, skip, pageSize }) {
        this.total = total;
        this.skip = skip;
        this.pageSize = pageSize;
        this.cd.markForCheck();
    }
}
PagerInputComponent.ɵfac = function PagerInputComponent_Factory(t) { return new (t || PagerInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(PagerContextService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
PagerInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PagerInputComponent, selectors: [["kendo-datapager-input"]], viewQuery: function PagerInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(NumericTextBoxComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.numericInput = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 17, consts: [[3, "ngClass"], ["format", "n0", 3, "spinners", "decimals", "disabled", "value", "min", "max", "autoCorrect", "title", "kendoEventsOutsideAngular"]], template: function PagerInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelement(2, "kendo-numerictextbox", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction0(13, _c3));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.textFor("page"), " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("spinners", false)("decimals", 0)("disabled", !ctx.hasPages)("value", ctx.current)("min", ctx.hasPages ? 1 : 0)("max", ctx.totalPages)("autoCorrect", true)("title", ctx.textFor("pageNumberInputTitle"))("kendoEventsOutsideAngular", ɵngcc0.ɵɵpureFunction2(14, _c4, ctx.handleKeyDown, ctx.handleBlur));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate2(" ", ctx.textFor("of"), " ", ctx.totalPages, " ");
    } }, directives: [ɵngcc3.NgClass, ɵngcc4.NumericTextBoxComponent, ɵngcc5.EventsOutsideAngularDirective], encapsulation: 2 });
/** @nocollapse */
PagerInputComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: PagerContextService },
    { type: NgZone },
    { type: ChangeDetectorRef }
];
PagerInputComponent.propDecorators = {
    numericInput: [{ type: ViewChild, args: [NumericTextBoxComponent, { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerInputComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-datapager-input',
                template: `
     <span [ngClass]="{'k-pager-input': true, 'k-label': true}">
        {{textFor('page')}}
        <kendo-numerictextbox
            [spinners]="false"
            [decimals]="0"
            format="n0"
            [disabled]="!hasPages"
            [value]="current"
            [min]="hasPages ? 1 : 0"
            [max]="totalPages"
            [autoCorrect]="true"
            [title]="textFor('pageNumberInputTitle')"
            [kendoEventsOutsideAngular]="{
                keydown: handleKeyDown,
                focusout: handleBlur
            }">
        </kendo-numerictextbox>
        {{textFor('of')}} {{totalPages}}
     </span>
    `
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }, { type: PagerContextService }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }]; }, { numericInput: [{
            type: ViewChild,
            args: [NumericTextBoxComponent, { static: true }]
        }] }); })();

// tslint:disable:no-access-missing-member
/**
 * Displays information about the current page and the total number of records ([see example]({% slug pager_settings %})).
 */
class PagerInfoComponent extends PagerElementComponent {
    constructor(localization, cd, pagerContext) {
        super(localization, pagerContext, cd);
        this.pagerContext = pagerContext;
    }
    /**
     * @hidden
     *
     * @readonly
     * @type {number}
     * @memberOf PagerInfoComponent
     */
    get maxItems() {
        return Math.min(this.currentPage * this.pageSize, this.total);
    }
    /**
     * @hidden
     *
     * @readonly
     * @type {number}
     * @memberOf PagerInfoComponent
     */
    get currentPageText() {
        return this.total ?
            (this.currentPage - 1) * this.pageSize + 1 :
            0;
    }
    /**
     * @hidden
     *
     * @readonly
     * @type {boolean}
     * @memberOf PagerInfoComponent
     */
    get classes() {
        return true;
    }
    onChanges({ total, skip, pageSize }) {
        this.total = total;
        this.skip = skip;
        this.pageSize = pageSize;
        this.cd.markForCheck();
    }
}
PagerInfoComponent.ɵfac = function PagerInfoComponent_Factory(t) { return new (t || PagerInfoComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(PagerContextService)); };
PagerInfoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PagerInfoComponent, selectors: [["kendo-datapager-info"]], hostVars: 4, hostBindings: function PagerInfoComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-pager-info", ctx.classes)("k-label", ctx.classes);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 5, template: function PagerInfoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0);
    } if (rf & 2) {
        ɵngcc0.ɵɵtextInterpolate5("", ctx.currentPageText, " - ", ctx.maxItems, " ", ctx.textFor("of"), " ", ctx.total, " ", ctx.textFor("items"), "");
    } }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
PagerInfoComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: ChangeDetectorRef },
    { type: PagerContextService }
];
PagerInfoComponent.propDecorators = {
    classes: [{ type: HostBinding, args: ["class.k-pager-info",] }, { type: HostBinding, args: ["class.k-label",] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerInfoComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                selector: 'kendo-datapager-info',
                template: `{{currentPageText}} - {{maxItems}} {{textFor('of')}} {{total}} {{textFor('items')}}`
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }, { type: PagerContextService }]; }, { classes: [{
            type: HostBinding,
            args: ["class.k-pager-info"]
        }, {
            type: HostBinding,
            args: ["class.k-label"]
        }] }); })();

/**
 * @hidden
 */
const RESPONSIVE_BREAKPOINT_MEDIUM = 600;
/**
 * @hidden
 */
const RESPONSIVE_BREAKPOINT_LARGE = 768;

/**
 * @hidden
 */
const DEFAULT_PAGE_SIZE_VALUES = [5, 10, 20];

class PagerComponent {
    constructor(pagerContext, element, localization) {
        this.pagerContext = pagerContext;
        this.element = element;
        this.localization = localization;
        /**
         * Represents the total number of data items in the collection.
         */
        this.total = 0;
        /**
         * Defines the number of data items to be skipped.
         */
        this.skip = 0;
        /**
         * Sets the maximum numeric buttons count before the buttons are collapsed.
         */
        this.buttonCount = 10;
        /**
         * Toggles the information about the current page and the total number of records.
         */
        this.info = true;
        /**
         * Defines the type of the pager.
         */
        this.type = 'numeric';
        /**
         * Toggles the **Previous** and **Next** buttons.
         */
        this.previousNext = true;
        /**
         * Fires when the current page of the Pager is changed ([see example]({% slug overview_pager %}#toc-basic-usage)).
         * You have to handle the event yourself and page the data.
         */
        this.pageChange = new EventEmitter();
        /**
         * Fires when the page size of the Pager is changed.
         * You have to handle the event yourself and page the data.
         * If the event is prevented, the page size will remain unchanged ([see example]({% slug pager_events %})).
         */
        this.pageSizeChange = new EventEmitter();
        this.pagerWrapClass = true;
        this.pagerClass = true;
        this.widgetClass = true;
        this.widgetRole = 'navigation';
        this.subscriptions = new Subscription();
        this._templateContext = {};
        this._pageSizeValues = DEFAULT_PAGE_SIZE_VALUES;
        this.resizeHandler = () => {
            if (this.template) {
                return;
            }
            const element = this.element.nativeElement;
            const width = element.offsetWidth;
            if (width < RESPONSIVE_BREAKPOINT_MEDIUM) {
                element.classList.remove('k-pager-md');
                element.classList.add('k-pager-sm');
            }
            else if (width >= RESPONSIVE_BREAKPOINT_MEDIUM && width < RESPONSIVE_BREAKPOINT_LARGE) {
                element.classList.add('k-pager-md');
                element.classList.remove('k-pager-sm');
            }
            else {
                element.classList.remove('k-pager-md');
                element.classList.remove('k-pager-sm');
            }
        };
        this.direction = localization.rtl ? 'rtl' : 'ltr';
    }
    /**
     * Shows a dropdown for selecting the page size.
     * When set to `true`, the dropdown will contain the default list of options - 5, 10, 20.
     * To customize the list of options, set `pageSizeValues` to an array of the desired values.
     * The array can contain numbers and [PageSizeItem]({% slug api_pager_pagesizeitem %}) objects.
     */
    set pageSizeValues(pageSizeValues) {
        this._pageSizeValues = Array.isArray(pageSizeValues) ? pageSizeValues : pageSizeValues ? DEFAULT_PAGE_SIZE_VALUES : false;
    }
    get dir() {
        return this.direction;
    }
    get totalPages() {
        return Math.ceil((this.total || 0) / this.pageSize);
    }
    get currentPage() {
        return Math.floor((this.skip || 0) / this.pageSize) + 1;
    }
    get pageSizeValues() {
        return this._pageSizeValues;
    }
    get templateContext() {
        const context = this._templateContext;
        context.totalPages = this.totalPages;
        context.total = this.total;
        context.skip = this.skip;
        context.pageSize = this.pageSize;
        context.currentPage = this.currentPage;
        return context;
    }
    ngOnInit() {
        this.subscriptions.add(this.pagerContext.pageChange.subscribe(this.changePage.bind(this)));
        this.subscriptions.add(this.pagerContext.pageSizeChange.subscribe(this.changePageSize.bind(this)));
        this.subscriptions.add(this.resizeSensor.resize.subscribe(() => this.resizeHandler()));
        this.subscriptions.add(this.localization.changes.subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
        }));
    }
    ngAfterViewInit() {
        this.resizeHandler();
    }
    ngOnChanges(changes) {
        if (anyChanged(["pageSize", "skip", "total"], changes, false)) {
            this.pagerContext.notifyChanges({
                pageSize: this.pageSize,
                skip: this.skip,
                total: this.total
            });
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    /**
     * @hidden
     */
    changePage(event) {
        this.pageChange.emit(event);
    }
    /**
     * @hidden
     */
    changePageSize(event) {
        this.pageSizeChange.emit(event);
        if (!event.isDefaultPrevented()) {
            if (event.newPageSize === 'all') {
                this.pageChange.emit({ skip: 0, take: this.total });
            }
            else {
                this.pageChange.emit({ skip: 0, take: event.newPageSize });
            }
        }
    }
    /**
     * @hidden
     */
    onPageSizeChange(event) {
        this.pageSizeChange.emit(event);
        if (!event.isDefaultPrevented()) {
            this.pageChange.emit({ skip: this.skip, take: event.newPageSize });
        }
    }
}
PagerComponent.ɵfac = function PagerComponent_Factory(t) { return new (t || PagerComponent)(ɵngcc0.ɵɵdirectiveInject(PagerContextService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
PagerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PagerComponent, selectors: [["kendo-datapager"]], contentQueries: function PagerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, PagerTemplateDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, viewQuery: function PagerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(ResizeSensorComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.resizeSensor = _t.first);
    } }, hostVars: 8, hostBindings: function PagerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.widgetRole)("dir", ctx.dir);
        ɵngcc0.ɵɵclassProp("k-pager-wrap", ctx.pagerWrapClass)("k-pager", ctx.pagerClass)("k-widget", ctx.widgetClass);
    } }, inputs: { total: "total", skip: "skip", buttonCount: "buttonCount", info: "info", type: "type", previousNext: "previousNext", pageSizeValues: "pageSizeValues", pageSize: "pageSize" }, outputs: { pageChange: "pageChange", pageSizeChange: "pageSizeChange" }, exportAs: ["kendoDataPager"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            PagerContextService
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 5, vars: 2, consts: [["kendoDataPagerLocalizedMessages", "", 6, "firstPage", "previousPage", "nextPage", "lastPage", "page", "of", "pageNumberInputTitle", "items", "itemsPerPage"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "buttonCount", 4, "ngIf"], [3, "pageSizes", 4, "ngIf"], [3, "buttonCount"], [3, "pageSizes"]], template: function PagerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵi18nAttributes(1, _c23);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵtemplate(2, PagerComponent_ng_container_2_Template, 1, 2, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(3, PagerComponent_ng_container_3_Template, 7, 6, "ng-container", 2);
        ɵngcc0.ɵɵelement(4, "kendo-resize-sensor");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.template == null ? null : ctx.template.templateRef);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.template == null ? null : ctx.template.templateRef));
    } }, directives: function () { return [LocalizedMessagesDirective, ɵngcc3.NgIf, ɵngcc5.ResizeSensorComponent, ɵngcc3.NgTemplateOutlet, PagerPrevButtonsComponent, PagerNumericButtonsComponent, PagerInputComponent, PagerNextButtonsComponent, PagerInfoComponent, PagerPageSizesComponent]; }, encapsulation: 2 });
/** @nocollapse */
PagerComponent.ctorParameters = () => [
    { type: PagerContextService },
    { type: ElementRef },
    { type: LocalizationService }
];
PagerComponent.propDecorators = {
    resizeSensor: [{ type: ViewChild, args: [ResizeSensorComponent, { static: true },] }],
    template: [{ type: ContentChild, args: [PagerTemplateDirective, { static: true },] }],
    total: [{ type: Input }],
    skip: [{ type: Input }],
    pageSize: [{ type: Input }],
    buttonCount: [{ type: Input }],
    info: [{ type: Input }],
    type: [{ type: Input }],
    pageSizeValues: [{ type: Input }],
    previousNext: [{ type: Input }],
    pageChange: [{ type: Output }],
    pageSizeChange: [{ type: Output }],
    pagerWrapClass: [{ type: HostBinding, args: ['class.k-pager-wrap',] }],
    pagerClass: [{ type: HostBinding, args: ['class.k-pager',] }],
    widgetClass: [{ type: HostBinding, args: ['class.k-widget',] }],
    widgetRole: [{ type: HostBinding, args: ['attr.role',] }],
    dir: [{ type: HostBinding, args: ['attr.dir',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-datapager',
                exportAs: 'kendoDataPager',
                providers: [
                    LocalizationService,
                    PagerContextService
                ],
                template: `
        <ng-container kendoDataPagerLocalizedMessages
            i18n-firstPage="kendo.pager.firstPage|The label for the first page button in the Pager"
            firstPage="Go to the first page"

            i18n-previousPage="kendo.pager.previousPage|The label for the previous page button in the Pager"
            previousPage="Go to the previous page"

            i18n-nextPage="kendo.pager.nextPage|The label for the next page button in the Pager"
            nextPage="Go to the next page"

            i18n-lastPage="kendo.pager.lastPage|The label for the last page button in the Pager"
            lastPage="Go to the last page"

            i18n-page="kendo.pager.page|The label before the current page number in the Pager"
            page="Page"

            i18n-of="kendo.pager.of|The label before the total pages number in the Pager"
            of="of"

            i18n-pageNumberInputTitle="kendo.pager.pageNumberInputTitle|The label for the pager input in the Pager"
            pageNumberInputTitle="Page Number"

            i18n-items="kendo.pager.items|The label after the total pages number in the Pager"
            items="items"

            i18n-itemsPerPage="kendo.pager.itemsPerPage|The label for the page size chooser in the Pager"
            itemsPerPage="items per page"
         >
        </ng-container>
        <ng-container
            *ngIf="template?.templateRef"
            [ngTemplateOutlet]="template.templateRef"
            [ngTemplateOutletContext]="templateContext">
        </ng-container>
        <ng-container *ngIf="!template?.templateRef">
            <kendo-datapager-prev-buttons *ngIf="previousNext"></kendo-datapager-prev-buttons>
            <kendo-datapager-numeric-buttons
                *ngIf="type === 'numeric' && buttonCount > 0"
                [buttonCount]="buttonCount">
            </kendo-datapager-numeric-buttons>
            <kendo-datapager-input *ngIf="type === 'input'"></kendo-datapager-input>
            <kendo-datapager-next-buttons *ngIf="previousNext"></kendo-datapager-next-buttons>
            <kendo-datapager-info *ngIf='info'></kendo-datapager-info>
            <kendo-datapager-page-sizes *ngIf="pageSizeValues" [pageSizes]="pageSizeValues"></kendo-datapager-page-sizes>
        </ng-container>
        <kendo-resize-sensor></kendo-resize-sensor>
  `
            }]
    }], function () { return [{ type: PagerContextService }, { type: ɵngcc0.ElementRef }, { type: ɵngcc1.LocalizationService }]; }, { total: [{
            type: Input
        }], skip: [{
            type: Input
        }], buttonCount: [{
            type: Input
        }], info: [{
            type: Input
        }], type: [{
            type: Input
        }], previousNext: [{
            type: Input
        }], pageChange: [{
            type: Output
        }], pageSizeChange: [{
            type: Output
        }], pagerWrapClass: [{
            type: HostBinding,
            args: ['class.k-pager-wrap']
        }], pagerClass: [{
            type: HostBinding,
            args: ['class.k-pager']
        }], widgetClass: [{
            type: HostBinding,
            args: ['class.k-widget']
        }], widgetRole: [{
            type: HostBinding,
            args: ['attr.role']
        }], pageSizeValues: [{
            type: Input
        }], dir: [{
            type: HostBinding,
            args: ['attr.dir']
        }], resizeSensor: [{
            type: ViewChild,
            args: [ResizeSensorComponent, { static: true }]
        }], template: [{
            type: ContentChild,
            args: [PagerTemplateDirective, { static: true }]
        }], pageSize: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
class LocalizedMessagesDirective extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
}
LocalizedMessagesDirective.ɵfac = function LocalizedMessagesDirective_Factory(t) { return new (t || LocalizedMessagesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.LocalizationService)); };
LocalizedMessagesDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LocalizedMessagesDirective, selectors: [["", "kendoDataPagerLocalizedMessages", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                useExisting: forwardRef(() => LocalizedMessagesDirective)
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
LocalizedMessagesDirective.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocalizedMessagesDirective, [{
        type: Directive,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        useExisting: forwardRef(() => LocalizedMessagesDirective)
                    }
                ],
                selector: '[kendoDataPagerLocalizedMessages]'
            }]
    }], function () { return [{ type: ɵngcc1.LocalizationService }]; }, null); })();

const importedModules = [
    CommonModule,
    NumericTextBoxModule,
    DropDownListModule,
    EventsModule,
    ResizeSensorModule
];
const INTERNAL_COMPONENTS = [
    PagerComponent,
    PagerPrevButtonsComponent,
    PagerNextButtonsComponent,
    PagerNumericButtonsComponent,
    PagerInputComponent,
    PagerInfoComponent,
    PagerPageSizesComponent,
    PagerTemplateDirective,
    LocalizedMessagesDirective,
    CustomMessagesComponent
];
const providers = [
    {
        provide: L10N_PREFIX,
        useValue: 'kendo.pager'
    }
];
/**
 * @hidden
 */
class PagerModule {
    static exports() {
        return [
            PagerComponent,
            PagerPrevButtonsComponent,
            PagerNextButtonsComponent,
            PagerNumericButtonsComponent,
            PagerInputComponent,
            PagerInfoComponent,
            PagerPageSizesComponent,
            PagerTemplateDirective
        ];
    }
}
PagerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PagerModule });
PagerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PagerModule_Factory(t) { return new (t || PagerModule)(); }, providers: [providers], imports: [[...importedModules]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PagerModule, { declarations: [PagerComponent, PagerPrevButtonsComponent, PagerNextButtonsComponent, PagerNumericButtonsComponent, PagerInputComponent, PagerInfoComponent, PagerPageSizesComponent, PagerTemplateDirective, LocalizedMessagesDirective, CustomMessagesComponent], imports: [CommonModule,
        NumericTextBoxModule,
        DropDownListModule,
        EventsModule,
        ResizeSensorModule], exports: [PagerComponent, PagerPrevButtonsComponent, PagerNextButtonsComponent, PagerNumericButtonsComponent, PagerInputComponent, PagerInfoComponent, PagerPageSizesComponent, PagerTemplateDirective, LocalizedMessagesDirective, CustomMessagesComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerModule, [{
        type: NgModule,
        args: [{
                declarations: [INTERNAL_COMPONENTS],
                exports: [INTERNAL_COMPONENTS],
                imports: [...importedModules],
                providers: [providers]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { LocalizedMessagesDirective, Messages, PagerContextService, PagerElementComponent, PreventableEvent, PageSizeChangeEvent, CustomMessagesComponent, PagerPrevButtonsComponent, PagerPageSizesComponent, PagerTemplateDirective, PagerNumericButtonsComponent, PagerNextButtonsComponent, PagerInputComponent, PagerInfoComponent, PagerComponent, PagerModule };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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